import { Check, Loader2, TriangleAlert } from 'lucide-react';
import { FC, Fragment } from 'react';

import { TranslationStatusWrapper } from './TranslationStatus.styled';

export type TranslationStatusData = 'pending' | 'success' | 'error' | undefined;

interface TranslationStatusProps {
  status: TranslationStatusData | undefined;
  onRegenerate?: () => void;
}

export const TranslationStatus: FC<TranslationStatusProps> = ({ status, onRegenerate }) => (

  <Fragment key={status}>
    {status && status !== 'success' && (
    <TranslationStatusWrapper status={status}>
      {status === 'pending' && (
      <>
        <Loader2 size={14} className="animate-spin" />
        Translation pending..
      </>
      )}
      {status === 'error' && (
      <>
        <TriangleAlert size={14} />
        {onRegenerate && (
        <button
          type="button"
          onClick={() => {
            onRegenerate();
          }}
          className="ml-1 flex items-center gap-1 text-xs
              hover:underline cursor-pointer"
        >
          {' '}
          Repair Translation
        </button>
        )}
      </>
      )}
    </TranslationStatusWrapper>
    )}
    {status && status === 'success' && (
    <Check size={14} color="green" />
    )}
  </Fragment>
);
